
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/home-and-commercial-electrical-solutions-sydney/network-cabling-and-home-automation-sydney",
      function () {
        return require("private-next-pages/services/home-and-commercial-electrical-solutions-sydney/network-cabling-and-home-automation-sydney.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/home-and-commercial-electrical-solutions-sydney/network-cabling-and-home-automation-sydney"])
      });
    }
  